import { forwardRef } from "react";
import { TextBadge, TEXT_BADGE_COLOR } from "@hireart/component-library";
import PropTypes from "prop-types";

const SUI_COLOR_MAP = {
  green: TEXT_BADGE_COLOR.SUCCESS,
  olive: TEXT_BADGE_COLOR.SUCCESS,
  teal: TEXT_BADGE_COLOR.SUCCESS,
  blue: TEXT_BADGE_COLOR.BLUE,
  red: TEXT_BADGE_COLOR.ERROR,
  yellow: TEXT_BADGE_COLOR.WARNING,
  orange: TEXT_BADGE_COLOR.WARNING,
  purple: TEXT_BADGE_COLOR.PURPLE,
  violet: TEXT_BADGE_COLOR.PURPLE,
};

const mapColor = (suiColor) =>
  SUI_COLOR_MAP[suiColor] || TEXT_BADGE_COLOR.NEUTRAL;

const Label = forwardRef(
  ({ color, content, children, className, ...rest }, ref) => {
    // Remove SUI-specific props that don't apply to TextBadge
    const {
      basic,
      size,
      pointing,
      corner,
      tag,
      ribbon,
      attached,
      horizontal,
      floating,
      circular,
      image,
      ...textBadgeProps
    } = rest;

    return (
      <TextBadge
        ref={ref}
        color={mapColor(color)}
        className={className}
        {...textBadgeProps}
      >
        {children || content}
      </TextBadge>
    );
  }
);

Label.displayName = "Label";

const LabelDetail = ({ children, className, ...rest }) => (
  <span className={className} {...rest}>
    {children}
  </span>
);

LabelDetail.displayName = "LabelDetail";
LabelDetail.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

const LabelGroup = ({ children, className, ...rest }) => (
  <div className={className} {...rest}>
    {children}
  </div>
);

LabelGroup.displayName = "LabelGroup";
LabelGroup.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

Label.Detail = LabelDetail;
Label.Group = LabelGroup;

// SUI-compat props are intentionally not prefixed with is/has
/* eslint-disable react/boolean-prop-naming */
Label.propTypes = {
  color: PropTypes.string,
  content: PropTypes.node,
  children: PropTypes.node,
  className: PropTypes.string,
  basic: PropTypes.bool,
  size: PropTypes.string,
  pointing: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  corner: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  tag: PropTypes.bool,
  ribbon: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  attached: PropTypes.string,
  horizontal: PropTypes.bool,
  floating: PropTypes.bool,
  circular: PropTypes.bool,
  image: PropTypes.bool,
};
/* eslint-enable react/boolean-prop-naming */

export { Label };
